import { Col, Row, Modal, Input, Form, message } from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useMutation } from "react-query";
import { duplicatePriceList } from "../../api/priceLists";
import { PriceListsInterface } from "./Interfaces";

type prop = {
    isDuplicatePriceOpen: boolean;
    setIsDuplicatePriceOpen: React.Dispatch<React.SetStateAction<boolean>>;
    itemToDuplicate: {
        name: string,
        id: number
    };
    setSaleLists: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
    setSaleListsSearch: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
};

const DuplicatePrice = ({ isDuplicatePriceOpen, setIsDuplicatePriceOpen, itemToDuplicate, setSaleLists, setSaleListsSearch }: prop) => {

    const [t] = useTranslation("common");
    const [name, setName] = useState("");

    const { mutateAsync: duplicatePriceListMutation, isLoading } = useMutation(
        "bills",
        ({ id, name }: { id: number, name: string }) =>
            duplicatePriceList({ priceListId: id, name: name }),
        {
            onSuccess: ({ data }) => {
                message.success(data.message)
                setSaleLists(data.data)
                setSaleListsSearch(data.data)
                setIsDuplicatePriceOpen(false)
            },
            onError: ({ response }) => {
                message.error(response.data.message)
            }
        }
    );

    const handleName = (event: any) => {
        setName(event.target.value);
    };

    const handleSubmit = () => {
        duplicatePriceListMutation({ id: itemToDuplicate.id, name: name })
    }

    return (
        <>
            <Modal
                centered
                okText={`${t("save")}`}
                open={isDuplicatePriceOpen}
                width={490}
                onCancel={() => setIsDuplicatePriceOpen(false)}
                closable={false}
                maskClosable={false}
                cancelText={`${t("cancel")}`}
                okButtonProps={{
                    style: {
                        height: "40px",
                        background: "#1677FF",
                        color: "#fff",
                        width: "100px",
                        backgroundColor: !name ? 'grey' : ''
                    },
                    disabled: !name,
                    loading: isLoading
                }}
                cancelButtonProps={{
                    style: {
                        color: "#1677FF",
                        border: "1px solid #1677FF",
                        height: "40px",
                        width: "100px",
                    },
                }}
                onOk={handleSubmit}
                destroyOnClose
            >
                <Form layout="vertical">
                    <Row>
                        <Col span={24}>
                            <Title title={`${t("confirm-duplicate")}`} />
                        </Col>
                        <br />
                        <br />
                        <Col span={24} className="modaltitleEdit">{`${t(
                            "please-confirm-duplicating"
                        )} 
                        ${itemToDuplicate.name}`}</Col>
                        <Col span={16}>
                            <Form.Item label={t("name")}>
                                <Input
                                    maxLength={50}
                                    placeholder={`${t("enter-new-name")}`}
                                    onChange={handleName}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default DuplicatePrice;
